<template>
  <button class="video-entry" v-bind:class="{ selected: video['_id'] === selectedVideo }" @click="selectVideo(video)">
    <img
      class="video-image"
      v-bind:class="{ videoImageSelected: video['_id'] === selectedVideo }"
      v-bind:src="tmdb_image_url"
      onerror="this.src='http://images.mixd.tv/images/default.png'"
      type="image/png"/>
    <div>
      <p class="video-title">{{ video.title }}</p>
      <div class="col-md-12 sub-headline">
          <div v-if="(!!video.target_data.web_url && video.target_data.web_url.includes('store.maxdome.de')) || (!!video.target_data.web_url_ppv)" class="floater badge badge-info">
            PPV
          </div>
          <div v-else class="floater badge badge-info">
            ABO
          </div>

          <div
            class="floater badge badge-info"
          >
            {{ video.target_data.dmb_genre }}
          </div>
          <div
            class="floater badge badge-info"
            v-if="video.xml_vod_data.sendung.__sort__02_standard.__sort__01_stammdaten.__sort__02_programm.__sort__17_produktion"
          >
            {{ video.xml_vod_data.sendung.__sort__02_standard.__sort__01_stammdaten.__sort__04_ausstrahlung.__sort__19_katalog_genre }}
          </div>
          <div
            class="floater badge badge-secondary"
            v-if="video.xml_vod_data.sendung.__sort__02_standard.__sort__01_stammdaten.__sort__02_programm.__sort__17_produktion"
          >
            {{ video.xml_vod_data.sendung.__sort__02_standard.__sort__01_stammdaten.__sort__04_ausstrahlung.__sort__04_dauer }} min
          </div>
          <div
            class="floater badge badge-secondary"
            v-if="video.xml_vod_data.sendung.__sort__02_standard.__sort__01_stammdaten.__sort__02_programm.__sort__17_produktion"
          >
            {{ video.xml_vod_data.sendung.__sort__02_standard.__sort__01_stammdaten.__sort__02_programm.__sort__17_produktion.__sort__02_jahr }}
          </div>

          <div
            class="floater badge badge-success"
            v-if="video.source_data.delta_info === 'update' &&
              video.vod_type !== 'movies' &&
              parseInt(video.xml_vod_data.sendung.__sort__01_id.substr(5,6)) <= 0"
          >
            Serien-Update
          </div>
          <div class="floater badge badge-warning" v-if="isSeasonUpdate">
            Staffel-Update
          </div>

          <p class="list-update-tag" v-if="video.source_data.delta_info === 'update'">Upd.</p>
          <p class="list-delete-tag" v-if="video.source_data.delta_info === 'deleted'">Del.</p>
          <p class="list-new-tag" v-if="video.source_data.delta_info === 'new'">New</p>
          <p class="list-tag" v-if="video.target_data.export_log">LOG</p>
          <p class="list-orig-tag" v-if="video.target_data.providerOriginal === true">
            Orig.
          </p>
          <p class="list-exclusive-tag" v-if="video.target_data.provider_exclusive === true">
            Excl.
          </p>

      </div>
      <p
        class="video-text"
        v-if="!video.xml_vod_data || !video.xml_vod_data.sendung.__sort__02_standard.__sort__01_stammdaten.__sort__02_programm.__sort__11_serie"
      >
        {{ video.target_data.description | truncate(75) }}
      </p>
      <p
        class="video-text"
        v-if="!video.xml_vod_data || video.xml_vod_data.sendung.__sort__02_standard.__sort__01_stammdaten.__sort__02_programm.__sort__11_serie"
      >
        <b>S{{ video.source_data.season | fillToTwoDigits }}E{{ video.source_data.episode | fillToTwoDigits }}</b> -
        {{ video.xml_vod_data.sendung.__sort__02_standard.__sort__01_stammdaten.__sort__02_programm.__sort__11_serie.folgentitel }}<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;({{ video.xml_vod_data.sendung.__sort__02_standard.__sort__01_stammdaten.__sort__02_programm.__sort__11_serie.originalfolgentitel }})
      </p>

      <p
        class="video-text"
        v-if="video.vod_type == 'series' &&
          !video.xml_vod_data.sendung.__sort__02_standard.__sort__01_stammdaten.__sort__02_programm.__sort__11_serie &&
          video.source_data.season &&
          video.source_data.episode"
      >
        <b>S{{ video.source_data.season | fillToTwoDigits }}E{{ video.source_data.episode | fillToTwoDigits }}</b> -
        {{ video.source_data.episodetitle }}<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;({{ video.source_data.oepisodetitle }})
      </p>

    </div>
    <div class="devider"></div>
  </button>
</template>

<script>
import axios from 'axios'
import '../compiled-icons/star'
const theMovieDb = require('themoviedb-javascript-library')

export default {
  name: 'Header',
  props: [
    'video',
    'selectedVideo',
    'globalImageUrlCache'
  ],
  data () {
    return {
      tmdb_image_url: this.tmdb_image_url
    }
  },
  mounted () {
    this.getTmdbImageUrl()
  },
  filters: {
    fillToTwoDigits: function (value) {
      if (!value) return ''
      let number = parseInt(value)
      if (number <= 99) {
        number = ('00' + number).slice(-2)
      }
      return number
    }
  },
  watch: {
    video: function (val) {
      // when the hash prop changes, this function will be fired.
      this.getTmdbImageUrl()
    }
  },
  computed: {
    isSeasonUpdate () {
      const entryId = this.video.xml_vod_data.sendung.__sort__01_id.substr(7, 4)
      // console.log('id', entryId)
      // console.log('substr', parseInt(entryId))
      // console.log('0', (parseInt(entryId) <= 0))

      return this.video.source_data.delta_info === 'update' &&
            this.video.vod_type !== 'movies' &&
            (parseInt(entryId) <= 0)
    }
  },
  methods: {
    getTmdbImageUrl () {
      this.$nextTick(function () {
        theMovieDb.common.api_key = '83b6a107b86cc443e3bc47a44474f521'
        let PLACEHOLER_IMAGE_PATH = 'http://images.mixd.tv/images/default.png'
        // console.log(this.video.source_data.tmdb)

        this.video.tmdb_image_url = PLACEHOLER_IMAGE_PATH
        this.tmdb_image_url = PLACEHOLER_IMAGE_PATH

        if (this.video.source_data.tmdb === null || this.video.source_data.tmdb === undefined) {
          if (this.video.source_data.imdb === null || this.video.source_data.imdb === undefined) {
            console.log('missing info')
          } else {
            let lookupUrl = 'http://vod-qa-dashboard.mixd.tv:3000/imdb_cover_url/' + this.video.source_data.imdb
            if (Object.keys(this.globalImageUrlCache).includes(lookupUrl)) {
              this.video.tmdb_image_url = this.globalImageUrlCache[lookupUrl]
              this.tmdb_image_url = this.video.tmdb_image_url
            } else {
              axios.get(lookupUrl).then(response => {
                this.globalImageUrlCache[lookupUrl] = response.data.coverUrl
                // console.log('setting to ' + response.data.coverUrl)
                this.video.tmdb_image_url = response.data.coverUrl
                this.tmdb_image_url = response.data.coverUrl
              })
            }
          }
        } else {
          theMovieDb.movies.getById({'id': this.video.source_data.tmdb, 'language': 'de'}, (data) => {
            let jsonData = JSON.parse(data)
            let posterPath = 'https://image.tmdb.org/t/p/w185_and_h278_bestv2' + jsonData['poster_path']
            // console.log('data is' + jsonData)
            this.video.tmdb_image_url = posterPath
            this.tmdb_image_url = posterPath
          }, () => { // (error) => {
            // console.log('error for ' + this.video.source_data.tmdb + 'Error:' + error)
            setTimeout(() => {
              if (this.tmdb_image_url === PLACEHOLER_IMAGE_PATH) {
                this.getTmdbImageUrl() // retrying
              }
            }, 3000)
          })
        } // else
      })
    },
    selectVideo () {
      this.$emit('on-selected-video', this.video)
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.video-entry {
  background-color: #fff;
  color: #000;
  margin-bottom: 1px;
  display: flex;
  padding: 0px;
  border: 0px;
  box-shadow: 0 0 2px #000000;
  margin: 2px;
}
.video-entry:hover {
  background-color: rgba(255,255,255,0.9);
  box-shadow: inset 0 0 1px #000000;
}
.list-tag {
  display: inline;
  position: absolute;
  right: 3px;
  top: -18px;
  background-color: red;
  color: white;
  width: 26px;
  padding: 2px;
  font-size: 10px;
  line-height: 10px;
  border-radius: 2px;
  box-shadow: inset 0 0 1px #000;
}
.list-update-tag {
  display: inline;
  position: absolute;
  right: 3px;
  top: -3px;
  background-color: green;
  color: black;
  width: 26px;
  padding: 2px;
  font-size: 10px;
  line-height: 10px;
  border-radius: 2px;
  box-shadow: inset 0 0 1px #000;
}
.list-delete-tag {
  display: inline;
  position: absolute;
  right: 3px;
  top: -3px;
  background-color: red;
  color: black;
  width: 26px;
  padding: 2px;
  font-size: 10px;
  line-height: 10px;
  border-radius: 2px;
  box-shadow: inset 0 0 1px #000;
}
.list-new-tag {
  display: inline;
  position: absolute;
  right: 3px;
  top: -3px;
  background-color: yellow;
  color: black;
  width: 26px;
  padding: 2px;
  font-size: 10px;
  line-height: 10px;
  border-radius: 2px;
  box-shadow: inset 0 0 1px #000;
}
.list-orig-tag {
  display: inline;
  position: absolute;
  right: 3px;
  top: 12px;
  background-color: #007bff;
  color: white;
  width: 26px;
  padding: 2px;
  font-size: 10px;
  line-height: 10px;
  border-radius: 2px;
  box-shadow: inset 0 0 1px #000;
}

.list-exclusive-tag {
  display: inline;
  position: absolute;
  right: 3px;
  top: 27px;
  background-color: #33aaff;
  color: black;
  width: 26px;
  padding: 2px;
  font-size: 10px;
  line-height: 10px;
  border-radius: 2px;
  box-shadow: inset 0 0 1px #000;
}

.selected {
  position: relative;
  left: 1px;
  background-color: rgba(255,255,255,0.8);
  box-shadow: inset 0 0 2px #000000;
  outline:0;
  margin-top: 4px;
  margin-bottom: 3px;
}
.ratings {
    font-size: 12px;
    color: #888;
    position: relative;
    bottom: 5px;
}
.sub-headline {
    padding-left: 5px;
    padding-right: 5px;
    text-align: left;
    font-size: 10px;
    color: #666;
    font-weight: bold;
}
.video-image {
  width: 48px;
}
.videoImageSelected {
  width: 46px;
  position: relative;
  top: 1px;
  left: 1px;
}
.video-title {
  text-align: left;
  padding-top: 3px;
  padding-left: 5px;
  padding-right: 5px;
  margin-bottom: 0px;
  color: #333;
  font-size: 12px;
  font-weight: bold;
  max-height: 20px;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  width: 246px;
}

.video-text {
  text-align: left;
  padding-left: 5px;
  padding-right: 5px;
  padding-top: 3px;
  padding-bottom: 3px;
  margin-bottom: 0px;
  height: 30px;
  width: 246px;
  font-size: 10px;
  color: #444;
  -webkit-line-clamp: 5;
  overflow: hidden;
  -webkit-box-orient: vertical;
  display: -webkit-box;
}

.devider{
  height: 1px;
  margin-left: 0px;
  margin-right: 0px;
  background-color: #bbb;
}

.video-more {
  padding-top: 10px;
  padding-bottom: 10px;
  text-align: center;
  font-size: small;
  color: #106AD7;
}

.floater {
  float: left;
}
</style>



// WEBPACK FOOTER //
// src/components/VideoEntry.vue